import * as React from 'react';
export const ZWSvg = React.forwardRef(function ZWSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement(
      'g',
      {
        fill: 'none',
        fillRule: 'evenodd',
        transform: 'translate(0 2)',
      },
      /*#__PURE__*/ React.createElement('path', {
        fill: '#24B47E',
        d: 'M1.994 0h12.012C15.106 0 16 .896 16 2.001H0A2 2 0 0 1 1.994 0ZM16 10c0 1.112-.893 2-1.994 2H1.994C.894 12 0 11.105 0 10h16Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#FCD669',
        d: 'M0 2h16v2H0V2Zm0 6h16v2H0V8Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#E25950',
        d: 'M0 4h16v4H0z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#333',
        d: 'M0 5h16v2H0z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#A68527',
        fillOpacity: 0.1,
        fillRule: 'nonzero',
        d: 'M15 4V2h1v2h-1ZM0 2h1v2H0V2Zm15 8V8h1v2h-1ZM0 8h1v2H0V8Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#F6F9FC',
        d: 'M.7 11.52A2.01 2.01 0 0 1 0 9.99V2.01C0 1.395.275.844.707.475a.504.504 0 0 1 .07.039L9 5.996.777 11.478a.5.5 0 0 1-.076.042Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#EAEEF3',
        d: 'M1.619 1.075A1 1 0 0 0 1 2v8a1 1 0 0 0 .611.922l-.834.556a.5.5 0 0 1-.076.042A2.01 2.01 0 0 1 0 9.99V2.01C0 1.395.275.844.707.475a.504.504 0 0 1 .07.039l.842.561Z',
      }),
      /*#__PURE__*/ React.createElement('circle', {
        cx: 3,
        cy: 6,
        r: 1,
        fill: '#E25950',
      }),
    ),
  );
});
ZWSvg.defaultProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
};
export var ZW = {
  category: 'flag',
  colorable: false,
  name: 'ZW',
  svg: ZWSvg,
};
